import { useState } from "react";

import { Form, FormElements, Link, Paragraph, validate } from "capitalrx-components-2.0";
import { useAlert } from "capitalrx-components-2.0/lib/general";
import { formatPhone } from "capitalrx-utilities";

import { useRequestDiscountCardMutation } from "@/api/getAdvantageCard";
import { CardResponse, CloseModalProp } from "@/types/AdvantageCardRequest";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { WhiteLabelSubmit } from "@/components/WhiteLabelComponents";

import styles from "../styles.module.scss";

const TextModal = (props: CloseModalProp): JSX.Element => {
  const { onClose } = props;
  const { TextField } = FormElements;

  const showAlert = useAlert();
  const [formattedNumber, setFormattedNumber] = useState("");

  const [requestCard, requestCardResult] = useRequestDiscountCardMutation();
  const group_number = useGroupNumber();

  const handleSubmit = async (payload: { discount_card_text: string }): Promise<CardResponse> => {
    await requestCard({
      request_type: 2,
      recipient: payload["discount_card_text"],
      group_number: group_number,
    })
      .unwrap()
      .then((data) =>
        showAlert({ message: "Text sent. You should receive a link for your discount card shortly.", type: "success", style: "toast" }),
      )
      .catch((data) => showAlert({ message: "Phone number was not submitted. Please try again.", type: "error", style: "toast" }));

    onClose();
    return requestCardResult.data;
  };

  const formatPhoneNumber = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setFormattedNumber(formatPhone(e));
  };

  return (
    <Form testId="advantage-modal-text" className={styles.ModalForm} onSubmit={handleSubmit}>
      <Paragraph className={styles.ModalFormTitle}>Text Discount Card</Paragraph>
      <Paragraph className={styles.ModalFormSubTitle}>Enter your phone number below to send this discount card to your phone.</Paragraph>
      <TextField
        name="discount_card_text"
        id="text-advantage"
        type="text"
        placeholder="(___) ___-____"
        onChange={formatPhoneNumber}
        validate={{ required: validate.required }}
        value={formattedNumber}
      />
      <WhiteLabelSubmit classNames={styles.ModalFormSubmit} text="Send Text" />
      <Paragraph className={styles.ModalFormDisclaimer}>
        By entering your phone number and selecting SEND, you agree that Msg &amp; data rates may apply. Terms and privacy information are
        available{" "}
        <Link href="https://cap-rx.com/legal" title="Terms and privacy information">
          here
        </Link>
        .
      </Paragraph>
    </Form>
  );
};

export default TextModal;
